<template>
  <div>{{lineTaxType}}</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnLineTaxType',
  computed: {
    ...mapGetters({
      lineTaxType: 'edit/lineTaxType'
    })
  }
}
</script>
